// extracted by mini-css-extract-plugin
export default {"button":"styles_button__5Qf0C","overlayActive":"styles_overlayActive__R2WJh","hidden":"styles_hidden__8Zv3a"};